export default __webpack_public_path__ + "static/media/ColumnSorting.b2585e83.svg";